import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Activity } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden bg-hex-pattern" data-id="element-145">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-bio-teal/5 rounded-full blur-[120px] pointer-events-none" data-id="element-146" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-147">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-148">
          <div className="order-2 lg:order-1" data-id="element-149">
            <FadeIn data-id="element-150">
              <div className="inline-flex items-center gap-2 px-3 py-1 border border-bio-teal/30 bg-bio-teal/5 mb-8" data-id="element-151">
                <Activity className="w-4 h-4 text-bio-teal animate-pulse" data-id="element-152" />
                <span className="font-mono text-xs text-bio-teal tracking-widest" data-id="element-153">
                  CLASSIFIED // CIVILIAN PROTOCOL
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-154">
              <h1 className="text-5xl md:text-7xl font-bold text-white leading-[1.1] mb-6 tracking-tight text-center lg:text-left" data-id="element-155">
                SOMIBO HEALING: <br data-id="element-156" />
                <span className="text-bio-teal text-glow-teal" data-id="element-157">
                  THE BIOCORP PROTOCOL
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-158">
              <h2 className="text-xl md:text-2xl text-bio-text font-inter font-light mb-8 leading-relaxed border-l-2 border-bio-amber pl-6" data-id="element-159">
                Biological armor and immune sovereignty: How to strengthen your
                cellular system so that no pandemic catches you unprepared.
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-160">
              <p className="text-bio-muted mb-10 text-lg leading-relaxed" data-id="element-161">
                The world has changed. The threats to your health are no longer
                seasonal—they are structural. While most people are paralyzed by
                the next headline, a small group of high-performers has stopped
                waiting for permission to be safe.
              </p>
            </FadeIn>

            <FadeIn delay={0.4} className="flex justify-center lg:justify-start mt-4" data-id="element-162">
              <Button onClick={() => document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })} data-id="element-163">
                <span data-id="element-164">BUILD MY</span>
                <span data-id="element-165">FORTRESS NOW</span>
              </Button>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-166">
            <FadeIn delay={0.2} data-id="element-167">
              <div className="relative" data-id="element-168">
                {/* Image frame accents */}
                <div className="absolute -inset-4 border border-bio-teal/20 bg-bio-dark/40 -z-10" data-id="element-169" />
                <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-bio-teal" data-id="element-170" />
                <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-bio-teal" data-id="element-171" />

                <img src="https://cdn.magicpatterns.com/uploads/xmft95bFU1iFJgiRwJaJKa/BioCorp_Mockup.png" alt="SOMIBO Healing Protocol Digital Access" className="w-full h-auto object-cover relative z-10 box-glow-teal" data-id="element-172" />

                {/* Scanning line animation overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-bio-teal/10 to-transparent h-10 w-full animate-[scan_4s_ease-in-out_infinite] z-20 pointer-events-none mix-blend-overlay" data-id="element-173" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}